// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1vXbo","rootSmall":"AddTileButton_rootSmall__9oEjp"};